<div class="flex flex-col w-full gap-1" style="color: #000">
    @if (label) {
        <label [attr.for]="id" class="font-bold">{{ label }}</label>
    }
    <p-select
        [placeholder]="placeholder"
        [options]="options"
        [id]="id"
        [filter]="true"
        (onChange)="changeValue($event)"
        [(ngModel)]="value"
        [readonly]="isReadOnly"
        appendTo="body"
        scrollHeight="200px"
        class="select-h8"
        styleClass="w-full {{
            height
        }} bg-white border border-gray-300 text-sm rounded-lg
            focus-within:outline-none focus-within:ring-2 focus-within:ring-emerald-300 min-w-0!"
    />
</div>